/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取娱伯牙模块列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.YbyModuleVO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/yby/module`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
